import { confirm } from "@/services/confirmService";

/**
 * Disponibiliza `this.$confirm(options)` em todos os componentes.
 * Ver API em services/confirmService.js.
 */
export default {
  install(Vue) {
    Vue.prototype.$confirm = confirm;
  },
};
